import React, { useCallback, useEffect, useState } from 'react';
import cx from 'classnames';
import { useTranslations } from 'next-intl';
import CommonIcon from '@/components/CommonIcon';
import UserActionCount from '@/components/UserActionCount/mIndex';
import DotLottie from '@/components/DotLottie';
import { IPCUserAction, useUserAction, USER_ACTION_TYPE, USER_ACTION_LOTTIE_URL } from './config';
import Styles from './index.module.scss';

const UserAction = ({
  tid,
  title,
  isLoggin = false,
  className = '',
  size = 'md',
  type,
  status,
  count,
  customCb = () => {},
  trackCb = () => {},
  onReportSlsData,
}: IPCUserAction) => {
  const { selected, cnt, showAnimation, handleUserAction, onComplete } = useUserAction({
    tid, title, isLoggin, status, count, customCb, trackCb, onReportSlsData
  });
  const t = useTranslations();
  // 只有动画资源真正就绪后，才隐藏静态图标，避免动效加载失败时出现空白。
  const [isAnimationReady, setIsAnimationReady] = useState(false);

  useEffect(() => {
    // 动画结束后重置 ready 状态，避免下一次交互沿用上一次的可见性。
    if (!showAnimation) {
      setIsAnimationReady(false);
    }
  }, [showAnimation]);

  // 由 DotLottie 回传运行时和资源是否已准备完成。
  const handleAnimationReadyStateChange = useCallback((ready: boolean) => {
    setIsAnimationReady(ready);
  }, []);

  return (
    <div className={cx(Styles.root, className, Styles[size])}>
      <CommonIcon
        className={cx(Styles.icon, Styles[type], { [Styles.noActive]: !selected, [Styles.hide]: showAnimation && isAnimationReady })}
        icon={!!selected ? `${type}-active` : type}
        onClick={() => handleUserAction(type)}
      />
      {showAnimation && (
        <DotLottie
          className={cx(Styles.dotLottie, {[Styles.show]: showAnimation})}
          autoplay
          loop={false}
          src={type === USER_ACTION_TYPE.PRAISE ? USER_ACTION_LOTTIE_URL.PRAISE : USER_ACTION_LOTTIE_URL.COLLECT}
          onComplete={onComplete}
          onReadyStateChange={handleAnimationReadyStateChange}
        />
      )}
      <UserActionCount className={Styles.actionNum} count={cnt} />
    </div>
  );
};

export { USER_ACTION_TYPE };

export default UserAction;
